<template>
  <div>
    <v-row>
      <v-col cols="12">
        <StudentProvinceDashboard/>
      </v-col>
      <v-col cols="12" md="12" class="pa-2">
        <Rate_work_college/>
      </v-col>
      <v-col cols="12">
        <ExecutiveDashboard/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ExecutiveDashboard from '../components/core/ExecutiveDashboard.vue';
import Rate_work_college from '../components/core/rate_work_college.vue';
import StudentProvinceDashboard from '../components/core/StudentProvinceDashboard.vue';

export default {
  components:{
    Rate_work_college,
    ExecutiveDashboard,
    StudentProvinceDashboard
  },
}
</script>
